// LogoutButtonCard.js
import React, { useState } from 'react';
import { Button, Card, CardContent, Grid, Modal, Box, Typography } from '@mui/material';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';

function LogoutButtonCard() {
  const { signOut } = useAuthenticator();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  // モーダルを開く
  const handleOpen = () => {
    setOpen(true);
  };

  // モーダルを閉じる
  const handleClose = () => {
    setOpen(false);
  };

  const handleSignOut = () => {
    signOut();
    navigate('/'); // ホームページに戻る
  };

  return (
    <>
      {/* ログアウトボタン */}
      <Card sx={{ boxShadow: 3, borderRadius: 5, padding: '0px 20px', maxHeight: '60px' }}>
        <CardContent sx={{ padding: '4px' }}>
          <Grid container justifyContent="flex-start">
            <Typography component="div" onClick={handleOpen} sx={{ fontSize:'1.2em', cursor: 'pointer', fontWeight: 'bold', paddingLeft: '16px', paddingTop: '12px', '&:hover': { textDecoration: 'underline' } }}>ログアウト</Typography>
          </Grid>
        </CardContent>
      </Card>

      {/* モーダル */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="logout-confirmation-title"
        aria-describedby="logout-confirmation-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 300,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            borderRadius: 10,
          }}
        >
          <Typography id="logout-confirmation-title" variant="h6" component="h2" align="center">
            ログアウトの確認
          </Typography>
          <Typography id="logout-confirmation-description" sx={{ mt: 2 }} align="center">
            ログアウトしますか？
          </Typography>
          <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
            <Grid item>
              <Button variant="contained" color="primary" onClick={handleSignOut}>
                ログアウトする
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" color="secondary" onClick={handleClose}>
                キャンセル
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}

export default LogoutButtonCard;
